import React, { useState,useEffect } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { NavMenu } from '../Navbar/NavbarElements';
import { HashLink as Link } from 'react-router-hash-link';
import {HiShoppingCart} from 'react-icons/hi';
import {IoIosCafe} from 'react-icons/io';
import {IoRestaurantSharp} from 'react-icons/io5';
import {MdTransitEnterexit} from 'react-icons/md';
import {IoBusiness} from 'react-icons/io5';
import {GiHouse} from 'react-icons/gi';
import {FaMountain} from 'react-icons/fa';

import {useLocation} from 'react-router-dom';
import './AmenitiesMenu.css';
import { Prev } from 'react-bootstrap/esm/PageItem';


function AmenitiesMenu() {

    const [scroll, setScroll] = useState('')

    
  useEffect(() => {
    
    
    document.addEventListener("scroll", () => {
        console.log(window.scrollY);
      const top = window.scrollY < 344 ;
      const transit = window.scrollY >= 344 && window.scrollY < 1839;
      const businessPark =   window.scrollY >= 1839 && window.scrollY < 2963;
      const sightSeeing = window.scrollY >= 2963 && window.scrollY < 3993;
      const restaurant =  window.scrollY >= 3993 && window.scrollY < 5381;
      const shopping = window.scrollY >= 5381 && window.scrollY < 8788;
      const cafe = window.scrollY >= 8788 && window.scrollY < 9394;
      const conventionCenter = window.scrollY >= 9394 && window.scrollY < 9565;
      const noMenu = window.scrollY >= 9565 ;

      switch (true)  {
        case top:
            setScroll("top");
            
            break;
        case shopping:
            setScroll("shopping");
            
            break;
        case cafe:
            setScroll("cafe");
            break;
        case restaurant:
            setScroll("restaurant");
            break;
        case transit:
            setScroll("transit");
            break;
        case businessPark:
            setScroll("businessPark");
            break
        case conventionCenter:
            setScroll("conventionCenter");
            break
        case sightSeeing:
            setScroll("sightSeeing");
            break  
        case noMenu:
            setScroll("noMenu");
            break    
          default:
              break;
      }
      
    })
  })

    

    return (
        <div className={scroll==='noMenu'?'disappear':'MenuWrapper'} >

            <ul id="MiniLeftNav">
                    <li id='transit' >
                        <Link className={scroll ==='transit'?"navtext activated":"navtext"} to="/placestovisit/#transit"><MdTransitEnterexit className={scroll ==='transit'?'SvgIcon1':'SvgIcon'}  /> 
                            <span>Transit</span>
                        </Link>
                    </li>
                    <li id='businessPark'>
                        <Link className={scroll ==='businessPark'?"navtext activated":"navtext"} to="/placestovisit/#business"><IoBusiness className={scroll ==='businessPark'?'SvgIcon1':'SvgIcon'} /> 
                            <span>Business Park</span>
                        </Link>
                    </li>
                    <li id='sightSeeing'>
                        <Link className={scroll ==='sightSeeing'?"navtext activated":"navtext"} to="/placestovisit/#sight"><FaMountain className={scroll ==='sightSeeing'?'SvgIcon1':'SvgIcon'} /> 
                            <span>Sight Seeing</span>
                        </Link>
                    </li>
                    <li id='restaurant'>
                        <Link className={scroll ==='restaurant'?"navtext activated":"navtext"} to="/placestovisit/#restaurant"><IoRestaurantSharp className={scroll ==='restaurant'?'SvgIcon1':'SvgIcon'} /> 
                            <span> Restaurants</span>
                        </Link>
                    </li>
                    <li id='shopping'>
                        <Link  
                        className={scroll ==='shopping'?"navtext activated":"navtext"}
                           to="/placestovisit/#shopping"><HiShoppingCart className={scroll ==='shopping'?'SvgIcon1':'SvgIcon'}  /> <span> Shopping</span></Link>
                    </li>
                    <li>
                        <Link className={scroll ==='cafe'?"navtext activated":"navtext"} to="/placestovisit/#cafe"><IoIosCafe className={scroll ==='cafe'?'SvgIcon1':'SvgIcon'} /> 
                            <span>Cafe</span>
                        </Link>
                    </li>
                    
                    
                    
                    <li>
                        <Link className={scroll ==='conventionCenter'?"navtext activated":"navtext"} to="/placestovisit/#convention"><GiHouse className={scroll ==='conventionCenter'?'SvgIcon1':'SvgIcon'} /> 
                            <span>Convention Centers</span>
                        </Link>
                    </li>
                    
</ul>
        </div>
    )
}

export default AmenitiesMenu
